
export const API_ENDPOINT = '/api';
export const API_TIMEOUT = 60000; 


export const DESIGNER_NAME = 'Gareth Owen Naicker';
export const COMPANY_NAME = 'Penrose';


export const STAR_COUNT = 80;
export const MAX_CONTENT_WIDTH = '4xl';


export const ANIMATION_DURATION = {
  FAST: 200,
  MEDIUM: 300,
  SLOW: 500,
};

export const RESPONSE_FIELDS = [
  'response',
  'text',
  'content',
  'choices[0].message.content',
  'choices[0].text',
  'data.response',
  'output',
];

